import apiUrl from '../../../../constants'
import axios from 'axios'
import PageTracker from '../../../../common/PageTrackerHelper';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {Validator} from 'vee-validate'
import moment from 'moment';

export default {
    name: 'ChangeShipmentStatus',
    components: {
        VueElementLoading,
        Validator
    },
    mixins:[PageTracker],
    data: function() {
        return {
            ShipmentStatus:[],
            ShippingId:'',
            isShipmentLoader:false,
            awbArray1:[],
            showTable:false,
            hubList:[],
            selfdebitdata:[],
            comments : '',
            selfdebitflag : false,
            styleObjectsp : {
              'color' : 'red'
            },
            invalidshipments:[],
            isLoader: false,
            userDataKey : '',
          }
     },
async mounted(){
  this.userDataKey = window.localStorage.getItem('userUniqueKey');
  let validateUser = await this.validateJwtToken();
  var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext)
  this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
  this.createdBy = userdetail.username;
  this.userid = userdetail.userid;
  this.Gethublist();
},
filters: {
  changeDateFormat: function(date) {
    if (date != null || date != '') {
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  }
},
methods : {
  showdetails(scope){
    this.$validator.validateAll(scope).then((result) => {
      if (result) {
        this.ShipmentStatus=[];
        this.comments='';
        this.showTable=true;
        this.isShipmentLoader=true;
        this.awbArray1 = [];
        this.resultshippingids = []
        this.selfdebitflag = false;
        this.invalidshipments = [];
        this.selfdebitdata = [];
            //for showing multiple shipment Ids
            let shippingidsWithNextLine = this.ShippingId.split("\n").map(String);
            let shippingidsWithComma = this.ShippingId.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }else if(shippingidsWithComma.length >= 1){

              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'lostshipmentinfo/SearchShipmentsForMarkLost',
          data: {
            "shipmentIds":this.awbArray1,
          },
          })
          .then(async result => {
            this.isShipmentLoader=false;
            if (result.data.code == 200) {
            if(result.data.data.length > 0){
              $.each(result.data.data, async(key,value) => {

                await this.hubList.forEach(function(hub){
                  if(value.CurrentHubID == hub.HubID){
                   value = Object.assign({ CurrentHubName:hub.HubName }, value);
                  }
                  if(value.FinalDestinationID == hub.HubID){
                    value = Object.assign({ FinalDestinationHubName:hub.HubName }, value);
                   }
                   if(value.OriginHubID == hub.HubID){
                    value = Object.assign({ OriginHubName:hub.HubName }, value);
                   }
               })
               let obj = {
                "ShippingId" : value.ShippingId,
                "CurrentHubID" : value.CurrentHubID,
                "ClientID" : value.ClientID,
                "ClientBusinessAccountID" : value.ClientBusinessAccountID,
                "ShipmentStatus" : value.ShipmentStatus,
                "Status" : value.Status,
                "CollectibleAmount" : value.CollectibleAmount,
                "DeclaredValue" : value.DeclaredValue
               }
               if( this.awbArray1.length !=  result.data.data.length){
                 this.resultshippingids.push(obj.ShippingId)
               }
               value.code = 200;
               this.ShipmentStatus.push(value);
               this.selfdebitdata.push(obj);
               if(key == result.data.data.length -1){
                 if(this.resultshippingids.length > 0){
                 await this.checkvalidshipments(this.resultshippingids,this.awbArray1);
               }
               }
            })
          } else {
              this.$alertify.error("No Records to Show!!!!!");
          }

            } else {
              this.$alertify.error(result.data.message)
              this.showTable=false;
            }
          })
          error => {
            this.isShipmentLoader=false;
            console.error(error)
           }
          }
        })
  },
  Gethublist()
  {
    let url = 'UpdateShipment/gethublist';
     axios.get(apiUrl.api_url + url)
     .then((response) => {
      if(response.data.code ==200){
        this.hubList = response.data.data
       }
       else{
        this.$alertify.error(result.data.message)
       }
      })
     .catch((httpException) => {
      this.$alertify.error("Shipment data not found");
      console.error('exception is:::::::::', httpException)
     })
  },
  confirmMarkShipmentLost(scope){
    this.$validator.validateAll(scope).then((result) => {
      if (result) {
    let message = {
      title: '',
      body: `<p>Are you sure, Do you really want to Mark Shipment Lost.</p>`,
    }
    let res = this.$dialog.confirm(message, {
      html: true,
      animation: 'bounce',
      backdropClose: true,
      okText: 'Yes',
      cancelText: 'No',
      reverse: true
      // loader: true
    })
    .then(dialog => {
    //  this.showdetails();
      this.markselfdebit();
    })
    .catch(() => {
      console.log('cancelled MarkShipmentLost Request.!');
    })
  }
})
  },
      resetForm1(){
        this.ShipmentStatus = '',
        this.ShippingId = '',
        this.invalidshipments = [],
        this.comments = ''
        // this.ShipmentStatus = []
        this.$validator.reset();
        this.errors.clear();
        this.selfdebitflag = false;
        this.isLoader = false;
        this.selfdebitdata = []
        this.awbArray1 = []
      },
      markselfdebit(){
        let input = {
          CreatedBy : this.createdBy,
          Comments : this.comments,
          optType: 'marklost',
          Shipments : this.selfdebitdata
        }
        this.isLoader = true;
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'lostshipmentinfo/selfDebitLostMark/billing',
          data: input
        })
        .then(result => {
          if(result.data.code == 200){
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.userid,
              username:this.createdBy,
              meta: {
                  "event":"markShipmentLost",
                  "Comments" : this.comments,
                  "optType": 'marklost',
                  "Shipments" : this.selfdebitdata.toString()
              }
            }
            this.PageTracker(TrackerInfo);
            this.selfdebitflag = true;
            this.ShipmentStatus.forEach((item, i) => {
              result.data.result.forEach((items, index) => {
                  if(item.ShippingId == items.shippingid){
                    item.response = items.message
                    item.code = items.code
                  }
              });
            });
            this.isLoader = false;
          }else {
            this.selfdebitflag = false;
            this.isLoader = false;
          }
        })
       .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
        this.isLoader = false;
       })
     },
     async checkvalidshipments(resultshippingids, awbArray){
       await awbArray.forEach((item, i) => {
         if(!resultshippingids.includes(item)){
           this.invalidshipments.push(item)
         }
       });
     }
      }
    }
    Validator.extend('VerifyShippingidFormat', {
      getMessage: field => "Maximum 50 Shipping IDs you can enter",
      validate: value => {
        var shippingids = $("#ShippingId").val();
        let shippingidNext = shippingids.split(/[\n]+/);
        let shippingidComma = shippingids.split(/[,]+/);
        if (shippingidNext.length > 50 || shippingidComma.length > 50) {
          return false;
        } else {
          return true;
        }
      }
    });



// WEBPACK FOOTER //
// ./src/views/components/LOST/CheckShipmentStatus/CheckShipmentStatus.component.js